import { consumer } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export function fetchPlaylist(playlistId: number): ApiAction<consumer.Playlist> {
  return {
    TockApi: {
      getProto: `/playlist/${playlistId}`,
      type: AppConstants.PLAYLIST_FETCH,
    },
  };
}
